import Permissions from '@/permissions'
import InterestRate from '@/views/interestRate/Index'
import { paydayInterestRateRouters } from '@/routers/interestRate/payday'
import { personalInterestRateRouters } from '@/routers/interestRate/personal'
import { pawnInterestRateRouters } from '@/routers/interestRate/pawn'
import { purchasingInterestRateRouters } from '@/routers/interestRate/purchasing'

export const interestRateRouters = {
  path: 'interest-rate',
  name: 'interest-rate',
  component: InterestRate,
  redirect: 'InterestRate',
  meta: {
    permissions: [Permissions.backend.interestRate.manage]
  },
  children: [
    paydayInterestRateRouters,
    personalInterestRateRouters,
    pawnInterestRateRouters,
    purchasingInterestRateRouters
  ]
}
